import { useFormContext } from 'react-hook-form';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { LocalizedTypography } from '@mews-commander/ui';
import { useDefaultFormContext } from '../../useDefaultFormValues';
import { PaymentRequestFormField, PaymentRequestFormValues, PaymentRequestType } from '../schema';

export const PaymentRequestFormTitle = () => {
    const isPaymentRequestCollectTypeEnabled = useFeatureFlag(FeatureFlag.paymentRequestCollectTypeEnabled);
    const { watch } = useFormContext<PaymentRequestFormValues>();

    const type = watch(PaymentRequestFormField.Type);

    const { allowedPaymentRequestTypeOptions } = useDefaultFormContext();

    if (allowedPaymentRequestTypeOptions.length === 1) {
        return null;
    }

    switch (type) {
        case PaymentRequestType.PaymentMethod:
            return (
                <LocalizedTypography
                    textStyle="titleSmallStrong"
                    textKey={TextKey.ProcessPaymentRequestCollectPaymentMethodTitle}
                    as="div"
                />
            );
        case PaymentRequestType.Payment:
            return isPaymentRequestCollectTypeEnabled ? (
                <LocalizedTypography
                    textStyle="titleSmallStrong"
                    textKey={TextKey.ProcessPaymentRequestCollectPaymentTitle}
                    as="div"
                />
            ) : null;
        case PaymentRequestType.Preauthorization:
            return (
                <LocalizedTypography
                    textStyle="titleSmallStrong"
                    textKey={TextKey.ProcessPaymentRequestPreauthorizePaymentTitle}
                    as="div"
                />
            );
        default:
            return null;
    }
};
